module.exports = __webpack_public_path__ + "static/media/KindbodyMaternityBooklet.7fe6fff3.pdf";